import EducationHead from '@/components/EducationHead'
import HaveQuestions from '@/components/HaveQuestions'
import { usePage } from '@/hooks'
import { booksWithScheme } from '@/images'
import React from 'react'
import VideoReviews from './components/VideoReviews'
import WhatToRead from './components/WhatToRead'

const RecommendToKnow = (): React.ReactElement => {
  const page = usePage()

  const { object } = page?.init_state
  const { config } = page?.init_state?.global

  return (
    <>
      <EducationHead
        title={object.title}
        backLink={config.education}
        backLinkTitle='Обучение'
        image={booksWithScheme}
        content={object.detail}
      />

      <WhatToRead role='teacher' />

      <VideoReviews />

      <HaveQuestions />
    </>
  )
}

export default RecommendToKnow
